<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Badge
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Badge Name"
                prepend-inner-icon="mdi-badge-account"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.type"
                :items="types"
                outlined
                label="Type"
                prepend-inner-icon="mdi-view-grid"
                clearable
                :rules="[rules.required]"
                @change="loadBadgesByType"
              ></v-autocomplete>
            </v-col>
            <v-col sm="12" v-if="form.type && badgesOfSameType.length > 0">
              <v-card outlined>
                <v-card-subtitle>
                  <v-icon small class="mr-2">mdi-information</v-icon>
                  Other badges in "{{ form.type }}" type ({{ badgesOfSameType.length }})
                </v-card-subtitle>
                <v-card-text>
                  <v-chip-group column>
                    <v-chip
                      v-for="badge in badgesOfSameType"
                      :key="badge.id"
                      small
                      outlined
                      :color="badge.id === form.id ? 'success' : 'primary'"
                    >
                      <v-icon left small v-if="badge.icon_url">mdi-badge-account</v-icon>
                      {{ badge.name }}
                      <v-icon right small v-if="badge.id === form.id">mdi-check</v-icon>
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.validity_type"
                :items="validityTypes"
                outlined
                label="Validity Type"
                prepend-inner-icon="mdi-calendar-clock"
                clearable
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-card-text-outline"
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
            <v-col sm="4" v-if="form.validity_type && form.validity_type !== 'permanent'">
              <v-text-field
                v-model.number="form.validity_value"
                outlined
                :label="`Validity Value (${form.validity_type})`"
                prepend-inner-icon="mdi-numeric"
                type="number"
                min="1"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
                accept="image/*"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (icon_url = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="icon_url" class="mt-5">
                <label for="">Icon Preview</label>
                <br />
                <img
                  :src="icon_url"
                  style="height: 80px; width: 80px !important"
                />
              </div>
              <div v-else-if="form.icon_url" class="mt-5">
                <label for="">Current Icon</label>
                <br />
                <img
                  :src="`${mediaUrl}${form.icon_url}`"
                  style="height: 80px; width: 80px !important"
                />
              </div>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Badge
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "BadgeIdPage",
  data() {
    return {
      form: {},
      old_json: {},
      isLoading: false,
      icon_url: "",
      badgesOfSameType: [],
      types: [
        { text: "Achievement", value: "achievement" },
        { text: "Activity", value: "activity" },
        { text: "Honor", value: "honor" },
      ],
      validityTypes: [
        { text: "Permanent", value: "permanent" },
        { text: "Days", value: "days" },
        { text: "Months", value: "months" },
      ],
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.badgeId;
      axios
        .get(`/badges/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log("form", this.form);
          this.old_json = response.data.data;
          // Load badges of same type after loading current badge
          if (this.form.type) {
            this.loadBadgesByType();
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        let badge = await axios.patch(
          `/badges/${this.$route.params.badgeId}`,
          this.form
        );
        this.badge = badge.data.data;
        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      if (this.$refs.file != null && this.$refs.file.files[0]) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.badge.id);
        formData.append("icon_url", attachment);
        await axios
          .post("upload_badges_icon", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },

    onFileChange() {
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.icon_url = URL.createObjectURL(this.file);
        };
        img.src = evt.target.result;
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },

    async loadBadgesByType() {
      if (!this.form.type) {
        this.badgesOfSameType = [];
        return;
      }
      try {
        let response = await axios.get(`/badges?type=${this.form.type}&rowsPerPage=100`);
        this.badgesOfSameType = response.data.data || [];
      } catch (error) {
        console.log("Error loading badges by type:", error);
        this.badgesOfSameType = [];
      }
    },

    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/badges/${this.form.id}`,
          from_name: "BadgeIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/badges");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
